/* eslint-disable flowtype/require-valid-file-annotation */

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Paper from 'material-ui/Paper'
import green from 'material-ui/colors/green'
import { Field, reduxForm } from 'redux-form'
import { FormControl } from 'material-ui/Form'
import Input from 'material-ui/Input'
import { toTitleCase } from '../utils/helpers'
import Typography from 'material-ui/Typography'
import withStyles from 'material-ui/styles/withStyles'

const PROP_TYPES = {
  initialValues: PropTypes.object.isRequired
}

const styles = theme => ({
  active: {
    color: green[500],
    marginTop: '1.25%',
    marginLeft: '-2%',
    fontSize: 13
  },
  form: {
    margin: '3%'
  },
  heading: {
    margin: '1%',
    width: '15%'
  },
  'input': {
    color: 'black',
    marginTop: '1%',
    fontSize: 13
  },
  paper: {
    width: '100%',
    overflowX: 'auto'
  },
  pending: {
    color: 'red',
    marginTop: '1.25%',
    marginLeft: '-2%',
    fontSize: 13
  },
  row: {
    display: 'flex'
  }
})

export class UserProfile extends Component {

  renderFields() {
    const { classes, initialValues } = this.props
    let markup = null
    if (initialValues.status) {
      const profile = {
        firstName: initialValues.firstName,
        lastName: initialValues.lastName,
        email: initialValues.email,
        status: initialValues.status
      }

      markup = Object.keys(profile).map((key, i) => {
        return (
          <span key={i} className={classes.row} data-test-id="form-row">
            <Typography type='subheading' color='secondary' className={classes.heading}>
              {toTitleCase(key.replace(/([A-Z])/g, ' $1'))}:
            </Typography>
            {key === 'status' ?
            <Typography className={profile.status.toLowerCase() === 'active' ? classes.active : classes.pending}>
              {toTitleCase(profile.status)}
            </Typography> :
            <Field
              classes={classes}
              name={key}
              key={i}
              component={this.renderTextField} />}
          </span>
        )
      })
    }
    return markup
  }

  renderTextField(props) {
    const { classes, input, name } = props
    return (
      <FormControl fullWidth={true}>
        <Input
          className={classes.input}
          id={name}
          {...input}
          disabled
          disableUnderline
          type='text' />
      </FormControl>
    )
  }

  render() {
    const { classes } = this.props
    return (
      <Paper className={classes.paper}>
        <form className={classes.form}>
          {this.renderFields()}
        </form>
      </Paper>
    )
  }
}

UserProfile.propTypes = PROP_TYPES
UserProfile = reduxForm({
  form: 'dialogValues',
  // known issue with dynamic Fields and validations,
  // below is a workaround to solve issue of it not validating
  // https://github.com/erikras/redux-form/issues/3276
  shouldValidate: () => true
})(UserProfile)

export default withStyles(styles)(UserProfile)
